export default "__VITE_ASSET__3b18b1f8__"